import { rankingData } from '@/mocks/homeData';

const changeIcons: Record<string, string> = {
  up: 'ri-arrow-up-fill',
  down: 'ri-arrow-down-fill',
  same: 'ri-subtract-line',
};
const changeColors: Record<string, string> = {
  up: 'text-accent-500',
  down: 'text-secondary-500',
  same: 'text-foreground-400',
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {rankingData.title}
        </h2>
        <div className="space-y-2 md:space-y-3">
          {rankingData.items.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-lg font-bold text-lg flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <span className="text-sm md:text-base font-medium text-foreground-800 block truncate">
                  {item.name}
                </span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">
                  {item.score}
                </span>
                <i
                  className={`${changeIcons[item.change]} ${changeColors[item.change]} text-sm`}
                ></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}